import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthService } from './auth.service';
import { ConfigurationService } from './configuration.service';
import { ErrorHandleService } from './error-handle.service';

@Injectable({
  providedIn: 'root'
})

export class EndpointFactory {
  static readonly apiVersion: string = "1";
  
  private _authService: AuthService;

  private get authService() {
    if (!this._authService)
      this._authService = this.injector.get(AuthService);

    return this._authService;
  }

  constructor(protected http: HttpClient, protected configurations: ConfigurationService,
    protected errorHandleService: ErrorHandleService, private injector: Injector) { }

  protected getRequestHeaders(): { headers: HttpHeaders | { [header: string]: string | string[]; } } {
    let headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.authService.accessToken,
      'Content-Type': 'application/json; charset=UTF-8',
      'Accept': `application/vnd.iman.v${EndpointFactory.apiVersion}+json, application/json, text/plain, */*`,
      'App-Version': ConfigurationService.appVersion
    });

    return { headers: headers };
  }

  getLoginEndpoint<T>(userId: string, password: string): Observable<T> {

    let header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    let params = new HttpParams()
      .append('username', userId)
      .append('password', password)
      .append('grant_type', 'password')
      .append('response_type', 'token')
      .append('scope', 'openid offline_access');

    let requestBody = params.toString();

    return this.http.post<T>(this.configurations.tokenUrl, requestBody, { headers: header });
  }

  getRefreshLoginEndpoint<T>(): Observable<T> {

    let header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    let params = new HttpParams()
      .append('refresh_token', this.authService.refreshToken)
      .append('grant_type', 'refresh_token')
      .append('scope', 'openid offline_access');

    let requestBody = params.toString();

    return this.http.post<T>(this.configurations.tokenUrl, requestBody, { headers: header }).pipe<T>(
      catchError(error => {
        return this.errorHandleService.handleError(error, () => this.getRefreshLoginEndpoint());
      }));
  }
}
